import pdfIcon from './pdf.png';
import imgIcon from './img.png';
import docIcon from './doc.png';
import pptIcon from './ppt.png';
import xlsIcon from './xls.png';
import zoomBgIcon from './zoomBg.png';

export default {
  pdf: pdfIcon,
  img: imgIcon,
  doc: docIcon,
  ppt: pptIcon,
  xls: xlsIcon,
  zoomBg: zoomBgIcon
};
